<template>
    <div class="info-cards" v-show="isPreloader || cards?.length">
        <!-- ITEM -->
        <template v-if="isPreloader">
            <div v-for="skeleton in Array(3)" :key="skeleton" class="info-cards__item --skeletons">
                <div class="info-cards__item__header">
                    <MySkeleton />
                    <MySkeleton />
                </div>
                <MySkeleton />
                <MySkeleton />
                <MySkeleton />
            </div>
        </template>
        <template v-else>
            <div v-for="(item, idx) in cards" :key="idx" class="info-cards__item">
                <div class="info-cards__item__header">
                    <img v-if="item.icon" :src="item.icon" :alt="item.title" />
                    <h5>{{ item.title }}</h5>
                </div>
                <div v-if="item.content" v-html="item.content" class="info-cards__item__content"></div>
            </div>
        </template>
    </div>
</template>

<script>
import VueTypes from 'vue-types';
import { InfoCardItem } from './../../types';

export default {
    name: 'InfoCards',
    props: {
        isPreloader: VueTypes.bool.isRequired,
        cards: VueTypes.arrayOf(InfoCardItem).def([])
    },
    components: {
        MySkeleton: () => import('@/themes/novaporta/components/ui/MySkeleton')
    }
};
</script>

<style lang="scss">
@import './styles.scss';
</style>
